export default __webpack_public_path__ + "static/media/a-3d1152.cfb33067.svg";